import { render, staticRenderFns } from "./MenuColaborador.vue?vue&type=template&id=7bad47a2&scoped=true"
import script from "./MenuColaborador.vue?vue&type=script&lang=js"
export * from "./MenuColaborador.vue?vue&type=script&lang=js"
import style0 from "./MenuColaborador.vue?vue&type=style&index=0&id=7bad47a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bad47a2",
  null
  
)

export default component.exports